import { render, staticRenderFns } from "./HelpComp.vue?vue&type=template&id=506259b3&scoped=true&"
import script from "./HelpComp.vue?vue&type=script&lang=js&"
export * from "./HelpComp.vue?vue&type=script&lang=js&"
import style0 from "./HelpComp.vue?vue&type=style&index=0&id=506259b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506259b3",
  null
  
)

export default component.exports